import React, { useRef, useState, useEffect, useCallback } from 'react'
import styled from 'styled-components/macro'
import Input from '../Input'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: var(--size-spacing-08);
`

const InputStyled = styled(Input)``

const MFAappChallengeCode = ({ hasError, onChange, onSend, reset, resetCallback }) => {
  const [code, setCode] = useState('')
  const inputRef = useRef(null)

  const handleReset = useCallback(() => {
    setCode('')
    resetCallback(false)
  }, [resetCallback])

  const handleChange = value => {
    const checkedValue = checksIfValueIsANumber(value)
    setCode(checkedValue)
    if (code.length <= 6) onChange && onChange(checkedValue)
  }

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      e.preventDefault()
      if (code.length > 5) onSend && onSend()
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress)
    return () => {
      document.removeEventListener('keydown', handleKeyPress)
    }
    // eslint-disable-next-line
  }, [onSend])

  useEffect(() => {
    reset && handleReset()
  }, [reset, handleReset])

  useEffect(() => {
    inputRef.current.focus()
  }, [])

  return (
    <Wrapper>
      <InputStyled
        id="input-code"
        name="input-code"
        maxLength="6"
        errorMessage={hasError}
        onChange={e => handleChange(e.target.value)}
        placeholder="000000"
        type="text"
        value={code}
        ref={inputRef}
      />
    </Wrapper>
  )
}

function checksIfValueIsANumber(value) {
  return /^\d*$/.test(value) ? value : ''
}

export default MFAappChallengeCode
